export enum ComponentSwitchEnum {
    classes,
    metabolites,
    projects,
}

class ComponentSwitch {
    name: string

    enable = false
}

export default ComponentSwitch

export const Switches: {
    [key in ComponentSwitchEnum]: ComponentSwitch
} = {
    [ComponentSwitchEnum.classes]: {
        name: "classes",
        enable: false,
    },
    [ComponentSwitchEnum.metabolites]: {
        name: "metabolites",
        enable: false,
    },
    [ComponentSwitchEnum.projects]: {
        name: "projects",
        enable: false,
    },
    [ComponentSwitchEnum.projects]: {
        name: "projects",
        enable: false,
    },
}
